import { Button, Stack } from "@mui/material";
import PropTypes from "prop-types";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import ctaAddIconWhite from "../../assets/images/common/ctaAddIconWhite.svg";
import ctaBackIconBlack from "../../assets/images/common/ctaBackIconBlack.svg";

function NavbarPageInfo({
  pageTitle,
  pageWithBack,
  backPageLink,
  addCTAText,
  addCTALink,
  supportLink,
  supportLinkText,
}) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const navbarSearch = useSelector((e) => e.sidebar.navbarSearch);
  const programQuesCount = useSelector((e) => e.programs.programQuesCount);
  const contestListCount = useSelector((e) => e.tournaments.contestListCount);
  const userGroupsCount = useSelector((e) => e.users.userGroupsCount);

  const getTitleCounts = () => {
    if (pageTitle === "Questions DB") {
      return programQuesCount;
    } else if (pageTitle === "Assigned Contests") {
      return contestListCount;
    } else if (pageTitle === "Total User Groups") {
      return userGroupsCount;
    } else {
      return null;
    }
  };
  // Component for navbar search input
  return (
    <Stack
      className="dt-ta-nav-page-info-tbtns"
      spacing={2}
      direction="row"
      mt="27px">
      {pageTitle?.length > 0 && (
        <div className="dflex dt-ta-nav-page-info-tbtns-title">
          {pageWithBack && (
            <img
              className="animate__animated animate__fadeIn dt-ta-nav-page-info-tbtns-title1"
              src={ctaBackIconBlack}
              alt="add"
              onClick={() => navigate(backPageLink)}
            />
          )}
          <div className="dt-ta-nav-page-info-tbtns-title2">
            {pageTitle} {getTitleCounts() ? `(${getTitleCounts()})` : ""}
          </div>
        </div>
      )}
      {addCTALink?.length > 0 && (
        <>
          <a
            href={supportLink}
            target="_blank"
            className="dt-ta-nav-page-info-support"
            rel="noreferrer">
            {supportLinkText}
          </a>
          <Button
            className="animate__animated animate__fadeIn dt-ta-nav-page-info-tbtns-filled"
            variant="contained"
            onClick={() => navigate(addCTALink)}
            style={{ marginLeft: "16px" }}>
            <img className="cta-icon-add" src={ctaAddIconWhite} alt="add" />
            <span>{addCTAText}</span>
          </Button>
        </>
      )}
    </Stack>
  );
}

NavbarPageInfo.propTypes = {
  pageTitle: PropTypes.string,
  pageWithBack: PropTypes.bool,
  backPageLink: PropTypes.string,
  addCTAText: PropTypes.string,
  addCTALink: PropTypes.string,
};

// Define default props
NavbarPageInfo.defaultProps = {
  pageTitle: "",
  pageWithBack: false,
  backPageLink: "",
  addCTAText: "",
  addCTALink: "",
  supportLink: "",
  supportLinkText: "",
};

export default NavbarPageInfo;
